module.exports = __webpack_public_path__ + "static/media/doctor.8b6cef2c.png";